var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8C4.44771 8 4 8.44771 4 9V10C4 10.5523 4.44771 11 5 11H6C6.55229 11 7 10.5523 7 10V9C7 8.44771 6.55229 8 6 8H5zM9 9C9 8.44771 9.44771 8 10 8H11C11.5523 8 12 8.44771 12 9V10C12 10.5523 11.5523 11 11 11H10C9.44771 11 9 10.5523 9 10V9z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C3.44771 0 3 0.447708 3 1V2H2C0.895432 2 0 2.89543 0 4V13C0 14.1046 0.895432 15 2 15H14C15.1046 15 16 14.1046 16 13V4C16 2.89543 15.1046 2 14 2H13V1C13 0.447708 12.5523 0 12 0C11.4477 0 11 0.447708 11 1V2H5V1C5 0.447708 4.55229 0 4 0ZM2 6V13H14V6H2Z",
    fill: "currentColor"
  })));
}

export default SvgCalendar;